import React, { useState } from "react";
import Rating from '@mui/material/Rating';
import Bubble from "../Bubble";

function RatingList({ initialValue }) {
  const [rating, setRating] = useState(initialValue || 0);

  const handleChange = (event, newValue) => setRating(newValue);

  return (
    <Bubble sender="customer">
      <Rating
        name="bot-rating"
        value={rating}
        onChange={handleChange}
        readOnly={!!initialValue}
      />
    </Bubble>
  );
}

export default RatingList;
